/* eslint-disable import/export */
import MenuItem from './MenuItem';
export * from './MenuItem';
export default MenuItem;